export const fontFamilies = [
    { id: 0, value: 'courier', name: 'Courier', cls:'courier'},
    { id: 1, value: 'courierBold', name: 'Courier-Bold', cls:'courier bold' },
    { id: 2, value: 'courierBoldOblique', name: 'Courier-BoldOblique, Bold italic', cls:'courier bold italic' },
    { id: 3, value: 'courierOblique', name: 'Courier-Oblique, Italic', cls:'courier italic' },
    { id: 4, value: 'helvetica', name: 'Helvetica', cls:'helvetica'},
    { id: 5, value: 'helveticaBold', name: 'Helvetica-Bold', cls:'helvetica bold'},
    { id: 6, value: 'helveticaBoldOblique', name: 'Helvetica-BoldOblique, Bold italic',
      cls:'helvetica bold italic'},
    { id: 7, value: 'helveticaOblique', name: 'Helvetica-Oblique, Italic',
      cls:'helvetica italic'},
    { id: 8, value: 'timesRoman', name: 'Times-Roman', cls:'times'},
    { id: 9, value: 'timesBold', name: 'Times-Bold', cls:'times bold'},
    { id: 10, value: 'timesBoldItalic', name: 'Times-BoldItalic', cls:'times bold italic'},
    { id: 11, value: 'timesItalic', name: 'Times-Italic', cls:'times italic'},
    { id: 12, value: 'symbol', name: 'Symbol', cls:''},
    { id: 13, value: 'zapfDingbats', name: 'ZapfDingbats', cls:''},
  ];
export const fontFamilies_CJK = [
    { id: 0, value: 'courier', name: 'Courier', cls:'courier'},
    { id: 1, value: 'courierBold', name: 'Courier-Bold', cls:'courier bold' },
    { id: 2, value: 'courierBoldOblique', name: 'Courier-BoldOblique, Bold italic', cls:'courier bold italic' },
    { id: 3, value: 'courierOblique', name: 'Courier-Oblique, Italic', cls:'courier italic' },
    { id: 4, value: 'helvetica', name: 'Helvetica', cls:'helvetica'},
    { id: 5, value: 'helveticaBold', name: 'Helvetica-Bold', cls:'helvetica bold'},
    { id: 6, value: 'helveticaBoldOblique', name: 'Helvetica-BoldOblique, Bold italic',
      cls:'helvetica bold italic'},
    { id: 7, value: 'helveticaOblique', name: 'Helvetica-Oblique, Italic',
      cls:'helvetica italic'},
    { id: 8, value: 'timesRoman', name: 'Times-Roman', cls:'times'},
    { id: 9, value: 'timesBold', name: 'Times-Bold', cls:'times bold'},
    { id: 10, value: 'timesBoldItalic', name: 'Times-BoldItalic', cls:'times bold italic'},
    { id: 11, value: 'timesItalic', name: 'Times-Italic', cls:'times italic'},
    { id: 12, value: 'SimSun', name: 'SimSun', cls:'simsun'},
    //{ id: 12, value: 'symbol', name: 'Symbol', cls:''},
    //{ id: 13, value: 'zapfDingbats', name: 'ZapfDingbats', cls:''},
  ];
